import { Percomatic } from '@biggby-coffee/percomatic-typescript';
import { useRecoilState, useRecoilValue } from 'recoil';

import { Option } from '../../../components/Option';
import { HorizontalSelect } from '../../../components/HorizontalSelect';
import { useChangeVersion } from '../../hooks/api';
import { getOtherVersionsLabel } from '../../utils/getOtherVersionsLabel';
import {
	currentVersionState,
	isProductVersionOptionActiveState,
	modifyingState,
	productVersionsState
} from '../../atoms';

export const OtherVersions: React.FC = () => {
	const changeVersion = useChangeVersion();
	const modifying = useRecoilValue(modifyingState);

	const { selectedIndex, productVersions } =
		useRecoilValue(productVersionsState);

	const [isProductVersionOptionActive, setIsProductVersionOptionActive] =
		useRecoilState(isProductVersionOptionActiveState);

	const currentVersion = useRecoilValue(currentVersionState);

	const selected: Percomatic.Serialized.ProductVersion = productVersions[
		selectedIndex
	] ?? {
		id: 0,
		name: ''
	};

	if (!selected || productVersions.length === 0) return null;

	const versions = [
		...productVersions.map((version, originalIndex) => ({
			version,
			originalIndex
		})),
		...(currentVersion
			? [{ version: currentVersion, originalIndex: -1 }]
			: [])
	].sort((a, b) => a.version.prioirity - b.version.prioirity);

	return (
		<div className="product-other-versions">
			<Option
				isActive={isProductVersionOptionActive}
				header={{
					name: 'product-versions',
					left: getOtherVersionsLabel(
						versions.map(({ version }) => version.name)
					),
					right: currentVersion?.name ?? '',
					onClick: () =>
						setIsProductVersionOptionActive(active => !active)
				}}
			>
				<HorizontalSelect
					name="product-versions-selector"
					selectedIndex={versions.findIndex(
						({ originalIndex }) => originalIndex === -1
					)}
					items={versions.map(
						({ version: { name }, originalIndex }) => [
							name,
							originalIndex
						]
					)}
					clickHandler={originalIndex => {
						if (!modifying && originalIndex !== -1) {
							changeVersion(originalIndex);
						}
					}}
				/>
			</Option>
		</div>
	);
};
